module.exports = __webpack_public_path__ + "static/media/garage-active-vehicle-placeholder.b0a753b3.svg";